export default "__VITE_ASSET__BX$02FSR__"